import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

function isSuccess(res) {
  return res && (res.code === 0 || res.code === 200 || res.code === '0' || res.code === '200' || res.success || res.msg === 'success')
}

function resolveResponse(response, fallbackMessage) {
  const res = response.data
  if (isSuccess(res) || Array.isArray(res) || Array.isArray(res.data) || Array.isArray(res.records)) {
    return res
  }
  throw new Error((res && res.msg) || fallbackMessage)
}

function withCommunity(payload) {
  return {
    ...payload,
    communityId: payload && payload.communityId ? payload.communityId : getCommunityId()
  }
}

// 查询面积反馈列表
export function listAreaFeedback(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/room.listRoomAreaFeedback',
      method: 'get',
      params: withCommunity(params || {})
    }).then(response => {
      resolve(resolveResponse(response, '获取面积反馈列表失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

// 处理面积反馈
export function handleAreaFeedback(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/room.handleRoomAreaFeedback',
      method: 'post',
      data: withCommunity(data || {})
    }).then(response => {
      resolve(resolveResponse(response, '处理面积反馈失败'))
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询面积反馈详情
export function getAreaFeedbackDetail(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/room.getRoomAreaFeedbackDetail',
      method: 'get',
      params: withCommunity(params || {})
    }).then(response => {
      resolve(resolveResponse(response, '获取面积反馈详情失败'))
    }).catch(error => {
      reject(error)
    })
  })
}
